import { cloneDeep } from "lodash";
import { useState } from "react";
import Modal, { Styles } from "react-modal";
import { SelectionItem } from "../../CommonProps";
const carbizLogo = require("../../../src/assets/images/svg/carbiz-logo.svg").default;
const carbizVector = require("../../../src/assets/images/svg/carbiz-vector.svg").default;
const assessmentTickSvg = require("../../../src/assets/images/svg/assessment-tick.svg").default;

const modalStyles = {
  content: {
    height: "203px",
    width: "550px",
    margin: "auto",
    position: "absolute",
    top: "0%",
    left: "0%",
    right: "0%",
    bottom: "10%",
    background: "trasnparent",
    borderRadius: "20px",
    outline: "none",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.5)",
  },
};

const compassSelectionItemsList: SelectionItem[] = [
  { id: 1, value: "Own another vehicle", state: false },
  { id: 2, value: "I prefer ride-sharing services", state: false },
  { id: 3, value: "Not sure if I’m eligible", state: false },
  { id: 4, value: "I prefer public transportation", state: false },
  { id: 5, value: "Temporary circumstances", state: false },
  { id: 6, value: "Others", state: false },
];

export interface ICarbizAssessmentModalProps {
  modalState: number,
  bookingIsLoading: boolean;
  handleModalButtonClick: (action: string, selectedOption?: SelectionItem | null) => void;
}

const CarbizAssessmentDialog = ({ modalState, handleModalButtonClick, bookingIsLoading }: ICarbizAssessmentModalProps) => {
  const [selectionItems, setSelectionItems] = useState(compassSelectionItemsList);
  const [selectedItem, setSelectedItem] = useState<SelectionItem | null>(null);

  if(modalState == 2){
    modalStyles.content.bottom = "25%"
  }

  const handleSelectItem = (id: number) => {
    const tempSelectionItems = cloneDeep(compassSelectionItemsList);
    const updatedItems = tempSelectionItems.map((item) => ({
      ...item,
      state: item.id === id,
    }));
    setSelectedItem(updatedItems.find((item) => item.state) || null);
    setSelectionItems(updatedItems);
  };

  const renderModalBody = () => {
    return (
      <div className="container">
        {
          modalState == 1 ?
            <div className="carbiz-container">
              <div className="carbiz-illustration">
                <img
                  src={carbizVector}
                  alt="woman with child near car"
                  width={260}
                  height={220}
                  className="carbiz-vector"
                />
              </div>
              <div className="carbiz-content">
                <div className="carbiz-points">
                  <div className="point">
                    <img src={assessmentTickSvg} className="check" alt="Assessment Tick" />
                    <p>Relax with $0 excess</p>
                  </div>
                  <div className="point">
                    <img src={assessmentTickSvg} className="check" alt="Assessment Tick" />
                    <p>The car you need, delivered to you</p>
                  </div>
                  <div className="point">
                    <img src={assessmentTickSvg} className="check" alt="Assessment Tick" />
                    <p>Coverage for the duration of repairs</p>
                  </div>
                  {renderModalFooter()}
                </div>
              </div>
            </div>
            :
            <div className="option-container">
              {
                modalState == 2 ?
              <div className="options-grid">
                {selectionItems.map((item) => {
                  return (
                    <div onClick={() => handleSelectItem(item.id)} className={`option-button hover ${item.state && "selected"}`}>
                      {item.value}
                    </div>
                  );
                })}
              </div>
              :
               <p className="carbiz-message">
              A member of the Carbiz  <br /> team will be in contact with <br /> you shortly
            </p>
              }

              {renderModalFooter()}
            </div>
        }
      </div>
    );
  };

  const renderModalFooter = () => {
    if (modalState === 1) {
      return (
        <div className="carbiz-buttons">
          <button
            onClick={() => handleModalButtonClick("NOT_INTERESTED")}
            disabled={bookingIsLoading}
            className="btn-outline"
          >
            Maybe later
          </button>
          <button
            onClick={() => handleModalButtonClick("UPDATE_MODAL")}
            disabled={bookingIsLoading}
            className="btn-primary"
          >
            {bookingIsLoading ? "Please wait..." : "Book Now"}
          </button>
        </div>
      );
    }

    if (modalState === 2) {
      const isActive = selectionItems.some((item) => item.state === true);

      return (
        <button
          className={`continue-button ${isActive ? "active" : "disabled"}`}
          disabled={!isActive}
          onClick={() => {
            handleModalButtonClick("BOOK_IN", selectedItem);
            setSelectedItem(null)
            setSelectionItems(compassSelectionItemsList)
          }}
        >
          Continue
        </button>
      );
    }

    return (
      <button
        className="continue-button active"
        onClick={() => handleModalButtonClick("CONTINUE")}
      >
        Continue
      </button>
    );
  };

  return (
    <Modal
      className={"widthResponsive"}
      isOpen={true}
      //   onRequestClose={this.closeModal}
      style={modalStyles as Styles}
    >
      <div className="carbiz-ad">
        <div className="carbiz-header">
          <img src={carbizLogo} alt="carbiz-logo" className="carbiz-logo" />
          <h2 className="carbiz-title">
            Replacement cars <br /> that keep you moving
          </h2>
        </div>

        {renderModalBody()}

      </div>
    </Modal>
  );
};

export default CarbizAssessmentDialog;
